import mixins from '@synergycms_core/less/mixins';

export default {
  inputSelect: {},
  row: {},
  text: {},
  isSelected: {},
  isFocused: {},
  title: {},
  optionTitle: {
    font: data => '300 13px ' + data.fontFamily1,
    display: 'block',
    marginTop: '4px',
    '@media (min-width: 901px)': {
      fontSize: '16px',
      paddingBottom: '4px'
    }
  },
  selectBox: {
    width: 'calc(50% - 5px)',
    inputSelect: {
      row: {
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        cursor: 'default',
        '&$test': {
          position: 'relative'
        },
        '& $title': {
          position: 'absolute',
          top: '3px',
          left: '0',
          right: '20px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          color: '#9b9b9b',
          '& span': {
            display: 'block',
            fontSize: '11px',
            '@media (min-width: 901px)': {
              fontSize: '13px'
            }
          },
          '@media (min-width: 901px)': {
            left: '8px'
          },
          '&:lang(ar)':{
            left:'20px',
            right:0,
            '@media (min-width: 901px)':{
              left:'20px',
              right:'9px'
            }
          }
        },
        '& span': {
          '&$optionTitle': {
            position: 'absolute',
            padding: '16px 8px 3px 0',
            display: 'block',
            font: "300 13px 'Roboto', sans-serif",
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            height: '100%',
            '&:lang(ar)':{
              paddingLeft: "8px",
              paddingRight: "0",
              '@media (min-width: 901px)':{
                paddingLeft: "25px",
                paddingRight: "9px"
              }
            },
            '@media (min-width: 901px)': {
              padding: '21px 25px 3px 9px',
              fontSize: '16px'
            }
          }
        }
      },
      isSelected: {
        backgroundColor: 'inherit',
        color: '#000'
      },
      isFocused: {
        backgroundColor: '#2684FF',
        color: 'white',
        display: 'block'
      },
      '& > div': {
        '& > div:first-of-type': {
          '& input': {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            position: 'absolute'
          }
        }
      }
    },
    '@media (min-width: 901px)': {
      width: 'calc(50% - 19px)'
    }
  },
  paymentMethod: {
    font: data => '300 11px ' + data.fontFamily1,
    display: 'block',
    '@media (min-width: 901px)': {
      fontSize: '13px'
    }
  },
  hide: {
    display: 'none'
  },
  staticPayForm: {
    ...mixins.boxShadow('0 0 2px 0 rgba(0, 0, 0, 0.5)'),
    padding: '5px 25px 3px 9px',
    '&:lang(ar)':{
      paddingLeft: "9px",
      paddingRight: "25px"
    }
  }
};
